import { type AutoCompleteSuggestion } from './fetchPOISuggestions';
import { getPointOfInterestSuggestionType } from './getPointOfInterestSuggestionType';

export const extractSuburbFromAddressText = (secondaryText: string): string => {
  const australiaStates = /\b(VIC|WA|QLD|TAS|NSW|SA|ACT|NT)\b/;
  const matchedState = secondaryText.match(australiaStates);

  return matchedState ? secondaryText.slice(0, matchedState.index).trim() : secondaryText;
};

export const mapSuggestionToSelectedText = (suggestion: AutoCompleteSuggestion): string => {
  const suggestionTypes = suggestion.placePrediction.types;

  if (getPointOfInterestSuggestionType(suggestionTypes) === 'address') {
    const numberAndStreet = suggestion.placePrediction.structuredFormat.mainText.text;
    const suburb = extractSuburbFromAddressText(
      suggestion.placePrediction.structuredFormat.secondaryText.text,
    );
    return `${numberAndStreet}, ${suburb}`;
  }

  return suggestion.placePrediction.structuredFormat.mainText.text;
};
